import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Kufi_Arabic\",\"arguments\":[{\"subsets\":[\"arabic\"],\"weight\":\"400\",\"variable\":\"--font-kufi\",\"adjustFontFallback\":false,\"fallback\":[\"sans-serif\"],\"display\":\"swap\",\"preload\":false}],\"variableName\":\"kufi\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Kufi_Arabic\",\"arguments\":[{\"subsets\":[\"arabic\"],\"weight\":\"600\",\"variable\":\"--font-kufi-600\",\"adjustFontFallback\":false,\"fallback\":[\"sans-serif\"],\"display\":\"swap\",\"preload\":false}],\"variableName\":\"kufi600\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Kufi_Arabic\",\"arguments\":[{\"subsets\":[\"arabic\"],\"weight\":\"700\",\"variable\":\"--font-kufi-700\",\"adjustFontFallback\":false,\"fallback\":[\"sans-serif\"],\"display\":\"swap\",\"preload\":false}],\"variableName\":\"kufi700\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Ads/AdsChecker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Footer/PagesLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/OneSignal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Scripts/MetaPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/SocialMediaUtils.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/ThemedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/app/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.scss");
